<template>
    <div id="busiest-period">
        <div class="side-menubar-wrapper">
            <SideMenuBar selected-page="reports" selected-sub-page="busiest-period" />
        </div>
        <div class="busiest-period-container">
            <div class="header">
                <FilterTool v-model="filters" :isGraphShowing="true" :keep-state-on-query-params="true" />
            </div>
            <div
                v-if="loading"
                class="h-50 d-flex flex-column justify-content-center align-items-center text-align-center"
            >
                <a-spin />
                <p>{{ $t("message.loading") }}</p>
            </div>
            <div v-else class="busiest-period-container">
                <ChartsGraphic
                    :key="`${renderKey}`"
                    :data-prop="chartData"
                    sub-title="busiestPeriod"
                    v-if="chartData.length"
                />

                <div class="d-flex justify-content-center mt-5" v-else>
                    <ChartNotFound :title="$t('message.dataNotFound')" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SideMenuBar from "../../SideMenuBar";
import ChartsGraphic from "../../components/ChartsGraphic";
import FilterTool from "../archive/FilterTool";
import ChartNotFound from "../../components/ChartNotFound";
import { IS_CHARTS_PUBLIC } from "../../chatbot";
import ComingSoonWrapper from "./ComingSoonWrapper";
import { log2 } from "../../../../../utils/log2";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import _ from "lodash";
import moment from "moment";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";

const log = log2("BusiestPeriod");

export default {
    name: "BusiestPeriod",
    components: { ChartNotFound, FilterTool, ChartsGraphic, SideMenuBar, ComingSoonWrapper },
    data() {
        return {
            filters: {
                period: this.$route.query.period || "today",
                integration: this.$route.query.integration || null,
                storyId: this.$route.query.storyId || null,
                startDate: this.$route.query.startDate || moment().startOf("day").toISOString(),
                endDate: this.$route.query.endDate || moment().endOf("day").toISOString(),
            },
            renderKey: 0,
            IS_CHARTS_PUBLIC,
            chartData: [],
            loading: true,
        };
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
        }),
        ...mapMutations({
            SET_LARGE_HEADER: "app/SET_LARGE_HEADER",
        }),
        fetchConversations() {
            this.loading = true;
            if (this.filters.period !== "custom") {
                this.filters.startDate = null;
                this.filters.endDate = null;
                this.$router.replace({
                    query: {
                        period: this.filters.period,
                        integration: this.filters.integration,
                        storyId: this.filters.storyId,
                    },
                });
            }
            CHATBOT_API.REPORT.busiestPeriod(this.filters)
                .then(async (res) => {
                    const { result } = res.data;
                    log("chartData", result);
                    if (result.length) this.chartData = _.cloneDeep(result);
                    else this.chartData = [];
                    this.renderKey += 1;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    beforeDestroy() {
        this.SET_LARGE_HEADER(true);
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    mounted() {
        this.SET_LARGE_HEADER(false);
        this.listStories();
        this.fetchConversations();
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["chatbot.reports.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        filters: {
            handler(newVal) {
                if (newVal !== undefined) {
                    log("filters changed", this.filters);
                    this.fetchConversations();
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
#busiest-period {
    width: 100%;
    display: flex;
    height: 100vh;

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .busiest-period-container {
        width: 100%;

        .header {
            width: 100%;
        }

        .chart {
        }
    }
}
</style>
